import React from 'react';
import { PropTypes } from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { injectIntl } from 'react-intl';

const ScrollToTop = ({ elementId, intl }) => (
  <button
    type="button"
    className="scroll-to-top"
    onClick={ () => {
      if (elementId) {
        const element = document.getElementById(elementId);
        if (element) {
          element.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }
      } else {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      }
    } }
    aria-label={ intl.formatMessage({ id: 'scrollToTop.text' }) }
  >
    <FontAwesomeIcon icon="arrow-up" />
  </button>);

ScrollToTop.propTypes = {
  elementId: PropTypes.string,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired
};

ScrollToTop.defaultProps = {
  elementId: null
};

export default injectIntl(ScrollToTop);
